import React, { useEffect, useState } from 'react';
import './courseHighLightBar.css';
import C2wCourseHighLightDiv from '../../../../common/C2wHome/courseDetails/courseHighLightDiv';
import { useSelector } from 'react-redux';

function C2wCourseHighLightBar({ handleIndexRef }) {
  const tempIndex = useSelector((state) => state.data.activeContentTabIndex)
  const [selectedIndex, setSelectedIndex] = useState(tempIndex);
  const arr = [
    "Content",
    "Things included",
    "Videos",
    "Assignments",
    "Quiz",
    "Analytics",
    "Reviews",
    'Certification',
    "Rules & Regulations",
  ];

  useEffect(() => {
    setSelectedIndex(tempIndex)
  }, [tempIndex])

  /**
 * @constant renderedArr
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over the `arr` array to render a list of `C2wCourseHighLightDiv` components.
 * - Passes each object as `obj` prop and the current `index`.
 * - Sets `isSelected` prop to true if the current index matches `selectedIndex`.
 * - Adds an `onClick` handler to update `selectedIndex` state on click.
 * - Passes `handleIndexRef` callback to each component for additional handling.
 *
 * Usage:
 * - Used to display selectable highlight divs for courses or sections.
 *
 * Notes:
 * - A unique `key` prop is provided for React list rendering optimization.
 */
  const renderedArr = arr.map((obj, index) => (
    <C2wCourseHighLightDiv
      key={index}
      obj={obj}
      index={index}
      isSelected={selectedIndex === index}
      onClick={() => setSelectedIndex(index)}
    />
  ));

  return (
    <div className='C2wCourseHighLightBar_ctn'>
      <div className='C2wCourseHighLightBar__content'>
        {renderedArr}
      </div>
    </div>
  );
}

export default C2wCourseHighLightBar;
